import Image from 'next/image';
import React from 'react';

type IProps = {
  name: string;
  esimFor: string | null;
  flagName: string;
};

export const DestinationDetailsName = ({ name, esimFor, flagName }: IProps) => {
  return (
    <h1>
      <span className={'text-lg'}>{esimFor}</span>
      <div className={'flex items-center gap-2.5'}>
        <Image
          src={'/static/flags/flag_' + flagName + '.svg'}
          alt={name}
          width={40}
          height={40}
        />
        <span
          className={
            '-mt-2 mb-4 text-4xl font-semibold leading-none text-primary lg:mb-0 lg:text-6xl'
          }
        >
          {name}
        </span>
      </div>
    </h1>
  );
};
